<template>
    <div>
        <template v-if="initialized">
            <template v-if="releaseListData.length > 0 && getFilteredReleases(timeFrame).length > 0">
                <release-panel
                    v-for="(release, releaseIndex) in getFilteredReleases(timeFrame)"
                    :key="releaseIndex"
                    :delay="releaseIndex * 200"
                    :release-item="release"
                    :filter-by-content-type="filterByContentType"
                    data-gtm="releaseItem__openModal"
                    @show-release-modal="$emit('open-release-modal', release)" />
            </template>
            <template v-else>
                <div class="alert alert-info">
                    {{ noDataInfo }}
                </div>
            </template>
        </template>
        <template v-else>
            <div
                class="panelCard panelCard--skeleton padding-all-10 margin-bottom-20 overflow-hidden pos-relative opacity-0 animated fadeIn"
                :class="`panelCard--skeletonDelay${ panelDelay }`">
                <span>&nbsp;</span>
                <h4 class="hl-panelBoxSmall">
&nbsp;
                </h4>
            </div>
        </template>
    </div>
</template>

<script>
    import releasePanel from './releasePanel';

    export default {
        components: {
            'release-panel': releasePanel,
        },
        props: {
            releaseListData: {
                type: Array,
                default: () => [],
            },
            timeFrame: {
                type: Array,
                default: () => [],
            },
            filteredCategories: {
                type: Array,
                default: () => [],
            },
            initialized: {
                type: Boolean,
                required: true,
            },
            sortDescending: {
                type: Boolean,
                default: false,
            },
            noDataInfo: {
                type: String,
                default: '',
            },
            panelDelay: {
                type: Number,
                required: true,
            },
            filterByContentType: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                contentTypeKey: this.filterByContentType ? 'contentType' : 'contentCategory',
            };
        },
        methods: {
            getFilteredReleases(range) {
                const filteredReleases = this.releaseListData.filter(release => {
                    const releaseDate = new Date(Date.parse(release.releaseDate.date));

                    const isInFilteredCategory = this.filteredCategories.includes(release[this.contentTypeKey]);

                    return isInFilteredCategory &&
                        (releaseDate >= range[0] && releaseDate <= range[1].setHours(23, 59, 59, 999));
                });

                return this.sortDescending
                    ? filteredReleases
                    : filteredReleases.sort((a, b) => (a.releaseDate.date > b.releaseDate.date) ? 1 : -1);
            },
        },
    };
</script>
